import Reflux from 'reflux';

const Actions = Reflux.createActions({
  loadJSON: { }
});

export default Actions;



/** WEBPACK FOOTER **
 ** ./modules/actions/descriptor_actions.js
 **/